import { fireflyApi } from '@/app/lib/axios';
import { AccessTokenResponse } from '@/app/network/models/access-token-response';

export async function acceptInvite(email: string, inviteCode: string, firstName: string, lastName: string, password: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users/accept-invite',
    {
      email: email,
      invite_code: inviteCode,
      first_name: firstName,
      last_name: lastName,
      password: password
    }
  );
}

export async function createUser(firstName: string, lastName: string, email: string, password: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users',
    {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password
    }
  );
}

export async function forgotPassword(email: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users/recover-password',
    {
      email: email
    }
  );
}

export async function passwordLogin(username: string, password: string): Promise<AccessTokenResponse> {
  return await fireflyApi.post(
    'v1/oauth2/token',
    {
      grant_type: 'password',
      username: username,
      password: password
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  );
}

export async function refreshTokenLogin(refreshToken: string): Promise<AccessTokenResponse> {
  return await fireflyApi.post(
    'v1/oauth2/token',
    {
      grant_type: 'refresh_token',
      refresh_token: refreshToken
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  );
}

export async function resendEmailVerification(email: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users/resend-verification-email',
    {
      email: email
    }
  );
}

export async function resetPassword(token: string, newPassword: string, confirmPassword: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users/reset-password',
    {
      token: token,
      new_password: newPassword,
      confirm_password: confirmPassword
    }
  );
}

export async function verifyEmail(token: string): Promise<void> {
  return await fireflyApi.post(
    'v1/users/verify-email',
    {
      token: token
    }
  );
}
